export default "__VITE_ASSET__Cyd12NNf__"